const config = {
  type: 'modal',
  instanceName: 'messages/errorDialog',

  modalWidth: '400px',
  modalPadding: '20px',
  modalClassName: 'modal-error-dialog',

  fields: {}
};

export default config;



// WEBPACK FOOTER //
// ./src/store/forms/formsConfigs/forms/errorDialogFormConfig.js